import axios from "./axios";
export const getList = _ref => {
  let {
    list,
    language,
    searchText,
    count = 500,
    page,
    searchType
  } = _ref;
  let url = `/valuelist/v1/${list}`;
  let params = [];
  if (page) params.push(`page=${page}`);
  if (language) params.push(`lang=${language.toUpperCase()}`);
  if (searchText) params.push(`searchText=${searchText}`);
  // searchType searches by name (0) / id (1) / extId (2)
  if (searchType) params.push(`searchType=${searchType}`);
  if (params.length) url += `?${params.join('&')}`;
  return axios.get(url, {
    headers: {
      count
    }
  });
};
export const getTableId = tableName => {
  return axios.get(`/tables/v1/id/${tableName}`);
};
export const getTable = id => {
  return axios.get(`/tables/v1/${id}`);
};
export const getValues = (id, offset) => {
  return axios.get(`/tables/v1/${id}/values?offset=${offset}`);
};
export const searchValues = _ref2 => {
  let {
    entity,
    text,
    lang = '',
    count = 10
  } = _ref2;
  return axios.get(`/search/v1/fuzzySearch/${entity}`, {
    params: {
      count,
      text,
      lang
    }
  });
};
export const searchValuesByIds = _ref3 => {
  let {
    entity,
    ids,
    lang = '',
    fields,
    searchType
  } = _ref3;
  // searchType searches by name (0) / id (1) / extId (2)
  return axios.post(`/search/v1/fuzzySearch/${entity}/values`, {
    ids,
    lang,
    fields,
    searchType
  });
};
export const getValueLists = () => {
  return axios.get('/tables/v1');
};
export const createTable = data => {
  return axios.post(`/tables/v1`, data);
};
export const updateTable = (id, data) => {
  return axios.put(`/tables/v1/${id}`, data);
};
export const deleteValueList = id => {
  return axios.delete(`/tables/v1/${id}`);
};
export const getValue = (list, id, lang) => {
  let url = `list/v1/${list}/${id}`;
  if (lang) url += `?lang=${lang.toUpperCase()}`;
  return axios.get(url);
};
export const getValueDetails = (id, idValue) => axios.get(`/tables/v1/${id}/values/${idValue}`);
export const getValueListPage = function (page, list) {
  if (page === void 0) {
    page = 0;
  }
  return axios.get(`/list/v1/${list}?page=${page}`);
};
export const getValuesUsage = (id, idValue) => axios.get(`/tables/v1/${id}/values/${idValue}/usages`);
export const updateValueListOrder = (id, data) => axios.put(`/tables/v1/${id}/values/sort`, data);